import { ITicker } from '@kattana-io/common';
import { ILimitValid } from '../reducers/dex/limitReducer';
import { ETabs, ICoin } from '../reducers/dex/tradingReducer';
import { BASE_TOKEN } from './nativeCoins';
import { NATIVE_LIMITS_ENABLED } from '../../../helpers/constants';

const TICKER_NOT_FOUND = 'No pair with enough liquidity';
const NOT_ENOUGH_GAS = 'Not enough gas';
const CREATE_LIMIT_ORDER = 'Create';
const NOT_VALID = 'Input error';
const NATIVE_NOT_SUPPORTED = "Native tokens aren't supported yet";
const WRONG_DATE_RANGE = 'Date range is incorrect';
const CREATING_LIMIT_ORDER = 'Creating...';

export const getOrderCondition = (
  tab: ETabs,
  base: ICoin,
  quote: ICoin,
  valid: ILimitValid,
  loading: boolean,
  gasBalance?: number,
  meta?: ITicker,
  startDate?: Date | null,
  endDate?: Date | null
): { canCreate: boolean; label: string } => {
  if (loading) {
    return { canCreate: false, label: CREATING_LIMIT_ORDER };
  }
  if (
    !NATIVE_LIMITS_ENABLED &&
    (base.address === BASE_TOKEN || quote.address === BASE_TOKEN)
  ) {
    return { canCreate: false, label: NATIVE_NOT_SUPPORTED };
  }

  if (!meta) {
    return { canCreate: false, label: TICKER_NOT_FOUND };
  }

  if (!gasBalance) {
    return { canCreate: false, label: NOT_ENOUGH_GAS };
  }

  if (base.amount.isEqualTo(0)) {
    return { canCreate: false, label: CREATE_LIMIT_ORDER };
  }

  if (!valid.deadline || !valid.slippage || !valid.tradesCount) {
    return { canCreate: false, label: NOT_VALID };
  }

  if (
    tab === ETabs.WhaleLimit &&
    (!startDate || !endDate || !(endDate.getTime() - startDate.getTime() > 0))
  ) {
    return { canCreate: false, label: WRONG_DATE_RANGE };
  }

  return { canCreate: true, label: CREATE_LIMIT_ORDER };
};
